// Sale helpers: determine active sale state + build countdown label.
// A product is "on sale" when it has a sale_price and either no sale_ends_at,
// or sale_ends_at is in the future.

export const isOnSale = (product) => {
  if (!product) return false;
  if (product.sale_price == null) return false;
  if (Number(product.sale_price) >= Number(product.price)) return false;
  if (!product.sale_ends_at) return true;
  const ends = new Date(product.sale_ends_at).getTime();
  if (Number.isNaN(ends)) return true;
  return ends > Date.now();
};

export const salePercentOff = (product) => {
  if (!isOnSale(product)) return 0;
  const off = 1 - Number(product.sale_price) / Number(product.price);
  return Math.round(off * 100);
};

export const effectivePrice = (product) =>
  isOnSale(product) ? Number(product.sale_price) : Number(product.price);

// Returns "2D 4H 12M" style string, or null if the sale has no end / has ended.
export const saleCountdown = (product, nowMs) => {
  if (!isOnSale(product) || !product.sale_ends_at) return null;
  const ends = new Date(product.sale_ends_at).getTime();
  const diff = ends - (nowMs ?? Date.now());
  if (diff <= 0) return null;
  const days = Math.floor(diff / 86_400_000);
  const hours = Math.floor((diff % 86_400_000) / 3_600_000);
  const minutes = Math.floor((diff % 3_600_000) / 60_000);
  const seconds = Math.floor((diff % 60_000) / 1_000);
  if (days > 0) return `${days}D ${hours}H ${minutes}M`;
  if (hours > 0) return `${hours}H ${minutes}M ${seconds}S`;
  return `${minutes}M ${seconds}S`;
};
